// src/shared/importers.js — четене на Excel файлове за импорт (копия от app.js).

import { el } from './dom.js';
import { toast } from './toast.js';
import { bgToIso } from './dates.js';
import { withXlsx } from './xlsx.js';

export function impPick(r, keys) { for (const k of keys) { if (r[k] != null && String(r[k]).trim() !== '') return String(r[k]).trim(); } return ''; }
export function impNum(v, d) { const n = parseFloat(String(v).replace(',', '.')); return isNaN(n) ? (d || 0) : n; }
export function impDigits(s) { return String(s == null ? '' : s).replace(/[^0-9]/g, ''); }
export function parseDateCell(v) {
  if (v == null || v === '') return '';
  if (v instanceof Date) return new Date(Date.UTC(v.getFullYear(), v.getMonth(), v.getDate())).toISOString().slice(0, 10);
  if (typeof v === 'number') return new Date(Date.UTC(1899, 11, 30) + Math.round(v) * 86400000).toISOString().slice(0, 10);
  return bgToIso(String(v));
}
// Байтовете на файл → редове (обекти по заглавията на първия лист).
// CSV се декодира ОТДЕЛНО: касовите софтуери у нас често изнасят в
// Windows-1251, а XLSX.read върху суровите байтове би показал кирилицата
// като „Ð¨Ð¾Ð¿…". Първо опитваме строг UTF-8; ако не става — 1251.
export function impParseBuffer(buf, name) {
  let wb;
  if (/\.csv$/i.test(String(name || ''))) {
    let text;
    try { text = new TextDecoder('utf-8', { fatal: true }).decode(buf); }
    catch (e) { text = new TextDecoder('windows-1251').decode(buf); }
    // raw: CSV остава текст — иначе код „000123" става числото 123 и вече
    // не съвпада с кода на артикула. Числата и датите се разчитат после.
    wb = XLSX.read(text.replace(/^﻿/, ''), { type: 'string', raw: true });
  } else {
    wb = XLSX.read(buf, { type: 'array', cellDates: true });
  }
  const ws = wb.Sheets[wb.SheetNames[0]];
  return XLSX.utils.sheet_to_json(ws, { defval: '' });
}

// onRows(rows, file) — вторият аргумент е самият файл: POS импортът качва и
// оригинала. opts.accept разширява избора (напр. с .csv); без него е както
// досега, за да не се променят старите импорти.
export function impReadFile(onRows, opts) {
  const fi = el('input', { type: 'file', accept: (opts && opts.accept) || '.xlsx,.xls' });
  fi.addEventListener('change', async () => {
    const file = fi.files[0]; if (!file) return;
    let rows;
    try {
      const buf = await file.arrayBuffer();
      rows = await withXlsx(() => impParseBuffer(buf, file.name));
    } catch (e) { toast('Грешка при четене на файла.', true); return; }
    if (!rows.length) { toast('Файлът е празен.', true); return; }
    // Както досега: синхронен срив в обработчика не бива да минава мълчаливо.
    try { onRows(rows, file); } catch (e) { toast('Грешка при четене на файла.', true); }
  });
  fi.click();
}
export function statusFromLabel(s) {
  s = String(s || '').trim().toLowerCase();
  if (s === 'изпратена' || s === 'sent') return 'sent';
  if (s === 'платена' || s === 'paid') return 'paid';
  if (s === 'просрочена' || s === 'overdue') return 'overdue';
  return 'draft';
}

// Номера на документи, които се повтарят във файла за импорт. Сравнява се по
// цифрите (за да съвпаднат „0000000001" и „1"), а се връща както е записано.
export function importDupeNumbers(rows) {
  const NUM_KEYS = ['№ на документ', '№ Фактура', 'Номер', 'Фактура №', '№', 'number'];
  const seen = new Map();
  for (const r of rows || []) {
    const raw = impPick(r, NUM_KEYS);
    const key = impDigits(raw);
    if (!key) continue;
    if (!seen.has(key)) seen.set(key, { raw, count: 1 });
    else seen.get(key).count++;
  }
  return [...seen.values()].filter((v) => v.count > 1).map((v) => v.raw);
}

// Избор на фактурник при импорт на фактури. Ако фирмата има само един — минава без питане.
